// GarsonCagirButonu.js
// Konum: src/GarsonCagirButonu.js — Route: /cagir/:restaurantId/:tableId/:tableNumber

import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

const BACKEND = process.env.REACT_APP_API_URL;

export default function GarsonCagirButonu() {
  const { restaurantId, tableId, tableNumber: urlTableNumber } = useParams();
  const [durum, setDurum] = useState('idle');
  const [logoUrl, setLogoUrl] = useState(null);
  // URL'deki isim ilk açılışta anında gösterilsin diye başlangıç değeri olarak kullanılıyor,
  // ama backend'den güncel isim gelince (admin panelden değiştirilmişse) onunla değişir.
  const [tableNumber, setTableNumber] = useState(urlTableNumber);

  useEffect(() => {
    fetch(`${BACKEND}/call-waiter/business/${restaurantId}`)
      .then((res) => res.json())
      .then((data) => setLogoUrl(data?.logoUrl || null))
      .catch(() => {});
  }, [restaurantId]);

  useEffect(() => {
    fetch(`${BACKEND}/call-waiter/tables/${restaurantId}/${tableId}/info`)
      .then((res) => res.json())
      .then((data) => {
        if (data?.tableNumber) setTableNumber(data.tableNumber);
      })
      .catch(() => {}); // başarısız olursa URL'deki isimle devam eder
  }, [restaurantId, tableId]);

  const garsonCagir = async () => {
    if (durum !== 'idle') return;
    setDurum('calling');

    try {
      const res = await fetch(`${BACKEND}/call-waiter/call`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ restaurantId, tableId, tableNumber }),
      });

      if (!res.ok) {
        setDurum('sent');
        setTimeout(() => setDurum('idle'), 45000);
        return;
      }

      setDurum('sent');
      setTimeout(() => setDurum('idle'), 45000);
    } catch (err) {
      alert('Bağlantı sorunu oluştu, tekrar deneyin.');
      setDurum('idle');
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-8 bg-gray-900 px-6">
      {logoUrl && <img src={logoUrl} alt="Logo" className="max-h-24 max-w-[200px] object-contain" />}
      <p className="text-slate-400 text-sm font-bold tracking-widest uppercase">Masa {tableNumber}</p>

      <button
        onClick={garsonCagir}
        disabled={durum !== 'idle'}
        className={`w-64 h-64 rounded-full flex flex-col items-center justify-center gap-3 text-white font-semibold text-lg shadow-2xl transition-transform active:scale-95 ${
          durum === 'sent'
            ? 'bg-gradient-to-br from-green-400 to-green-600'
            : durum === 'calling'
            ? 'bg-gradient-to-br from-slate-600 to-slate-700'
            : 'bg-gradient-to-br from-orange-400 to-red-600'
        }`}
      >
        {durum === 'idle' && (
          <>
            <span className="text-6xl">🔔</span>
            <span>Garson Çağır</span>
          </>
        )}
        {durum === 'calling' && <span>Gönderiliyor...</span>}
        {durum === 'sent' && (
          <>
            <span className="text-5xl">✓</span>
            <span>Garson çağrıldı, geliyor</span>
          </>
        )}
      </button>
    </div>
  );
}